@if (messageId()) {
    <app-table
        [translatePrefix]="prefix"
        dataKey="id"
        [columns]="columns"
        [defaultSorters]="[{ column: 'readAt', direction: 'ASC' }]"
        [gridData]="store.data.getMessageRecipients()"
        [refreshCallback]="store.api.getMessageRecipients"
        [refreshCallbackFragment]="fragment"
        [additionalFilter]="additionalFilter()"
        [transformItem]="transformItem"
        [hideCheckboxes]="true"
        [showClearFilter]="false"
    ></app-table>
}
